import styled from "styled-components";

export const Container = styled.div`
  width: 93%;
  margin: 0;
  padding: 3.5%;
  h1 {
    font-size: 24px;
    font-family: DM Serif Display;
    font-weight: 400;
  }
  p {
    font-weight: 300;
    font-size: 14px;
  }
  h4 {
    font-size: 16px;
    font-weight: 600;
  }
`;

export const ImagesContainer = styled.div`
  padding: 2%;
  display: grid;
  background: whitesmoke;
  width: 96%;
  grid-template-columns: 50% 50%;
  align-items: center;
  margin: 0 auto;

  .leftImage {
    width: 100%;
  }
  @media (max-width: 800px) {
    display: block;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  margin-top: 5%;
  width: 100%;
  justify-content: space-between;
  span {
    width: 40%;
    display: block;
  }

  @media (max-width: 800px) {
    display: block;
    span {
      width: 100%;
    }
  }
`;

export const GridImages = styled.div`
  margin: 0;
  display: grid;
  grid-template-columns: 50% 50%;
  img {
    width: 100%;
  }

  @media (max-width: 800px) {
    display: none;
  }
`;

export const Map = styled.div`
  width: 50%;
  margin: 0;
  padding: 0;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }

  @media (max-width: 800px) {
    width: 100%;
    margin-top: 5%;
  }
`;

export const Review = styled.div`
  padding: 5%;
  width: 90%;
  background: whitesmoke;

  .user_profile {
    width: 5%;
  }

  @media (max-width: 800px) {
    width: 90%;
    .user_profile {
      width: 20%;
    }
  }
`;
